import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, SearchBar, ListView } from 'antd-mobile';
import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';

const NUM_SECTIONS = 100;
const NUM_ROWS_PER_SECTION = 100;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
    for (let i = 0; i < NUM_SECTIONS; i++) {
        const ii = (pIndex * NUM_SECTIONS) + i;
        const sectionName = `Section ${ii}`;
        sectionIDs.push(sectionName);
        dataBlobs[sectionName] = sectionName;
        rowIDs[ii] = [];

        for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
            const rowName = `S${ii}, R${jj}`;
            rowIDs[ii].push(rowName);
            dataBlobs[rowName] = rowName;
        }
    }
    sectionIDs = [...sectionIDs];
    rowIDs = [...rowIDs];
}

class SelectBank extends React.Component {
    constructor(...args) {
        super(...args);

        const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
        const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
        const dataSource = new ListView.DataSource({
            getRowData,
            getSectionHeaderData: getSectionData,
            rowHasChanged: (row1, row2) => row1 !== row2,
            sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
        });

        this.state = {
            tabName: 1,
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            searchValue:'',
            skipCount: 0,
            pageSize: 100,
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.init()
    }

    init(){
        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
        
        genData();
        this.getList();
    }

    getList(){
        const {searchValue} = this.state;
    
        post({
          url: api.selectBankList+'?app_stoken=' + getUrlParam('app_stoken') + '&activity=365',
          data:{
            bankName: searchValue
          }
        }).then((res) => {
            if(res.result === 'success' && res.data || res.data.length > 0){
              this.setState({
                data: res.data
              },()=>{
                // if(sectionIDs.length >= 100){
                //   this.setState({
                //     hasMore: false
                //   });
                // }
                // const hei = res.count>0?(document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop):0;
                //   this.setState({
                //     isLoading: false,
                //     // height: hei,
                //   });
              });
            }else{
              
            }
        }, (res)=>{
            console.log('查询列表失败', res)
        });
    }
    

    onChangeValue = (value) => {
        this.setState({searchValue:value})
    }

    render() {
        const {data, urlOps, searchValue} = this.state;
        // let index = data.length - 1;
        let index = 0;
        const row = data.map((item,index)=>{
            
            return (
                <div className="item" key={index} onClick={()=>{
                    href(`/bindBank?app_stoken=${getUrlParam('app_stoken')}&customerName=${getUrlParam('customerName')}&accountBankName=${item.bankName}&accountBankCode=${item.bankCode}&hcAccountBankInfoId=${getUrlParam('hcAccountBankInfoId')}&bankAccount=${getUrlParam('bankAccount')}&activityCode=${getUrlParam('activityCode')}`)
                }}>
                    <div className="left" style={{ width: '100%', height: 'auto', marginTop: '0.1rem' }}>
                        <span>
                            {item.bankName}
                        </span>
                    </div>
                </div>
            );
        })
        
        return (
            <div>
                <SearchBar
                    value={searchValue}
                    placeholder="搜索"
                    onSubmit={()=>this.getList()}
                    onClear={value => console.log(value, 'onClear')}
                    onChange={value=>this.onChangeValue(value)}
                />
                 {this.state.data.length>0?
                 <div className='am-list'>
                    {row}
                    {this.state.data.length>10?<p style={{ padding: '0 0.2rem' }}>最多支持100条数据展示，若无对应银行，请细化搜索条件～</p>:''}
                 </div>
                 :<div className="noData">
                <div>暂无数据</div>
            </div>}
                </div>
        );
    }
}
export default SelectBank;


// WEBPACK FOOTER //
// ./src/bindBank/index/select.js